import React, { useState } from 'react';
import { User, Shield, Bell, Settings, Monitor, CreditCard, Lock, ChevronDown, ChevronUp } from 'lucide-react';
interface SettingsAccordionProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
  userType: 'angel' | 'customer';
}
export const SettingsAccordion: React.FC<SettingsAccordionProps> = ({
  activeSection,
  setActiveSection,
  userType
}) => {
  const [expandedGroup, setExpandedGroup] = useState<'user' | 'app'>('user');
  const toggleGroup = (group: 'user' | 'app') => {
    setExpandedGroup(expandedGroup === group ? null : group);
  };
  return <div className="w-full bg-gray-50 dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800" data-id="element-18883">
      {/* User Settings Group */}
      <div className="border-b border-gray-200 dark:border-gray-800" data-id="element-18884">
        <button className="w-full flex items-center justify-between p-4 bg-gray-100 dark:bg-gray-800" onClick={() => toggleGroup('user')} data-id="element-18885">
          <span className="font-semibold text-sm text-gray-700 dark:text-gray-300" data-id="element-18886">
            User Settings
          </span>
          {expandedGroup === 'user' ? <ChevronUp size={18} className="text-gray-500" data-id="element-18887" /> : <ChevronDown size={18} className="text-gray-500" data-id="element-18888" />}
        </button>
        {expandedGroup === 'user' && <div className="py-1" data-id="element-18889">
            <button className={`w-full flex items-center gap-3 px-4 py-3 text-left ${activeSection === 'profile' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'text-gray-700 dark:text-gray-300'}`} onClick={() => setActiveSection('profile')} data-id="element-18890">
              <User size={18} data-id="element-18891" />
              <span data-id="element-18892">Profile</span>
            </button>
            <button className={`w-full flex items-center gap-3 px-4 py-3 text-left ${activeSection === 'account' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'text-gray-700 dark:text-gray-300'}`} onClick={() => setActiveSection('account')} data-id="element-18893">
              <Lock size={18} data-id="element-18894" />
              <span data-id="element-18895">Account</span>
            </button>
            <button className={`w-full flex items-center gap-3 px-4 py-3 text-left ${activeSection === 'privacy' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'text-gray-700 dark:text-gray-300'}`} onClick={() => setActiveSection('privacy')} data-id="element-18896">
              <Shield size={18} data-id="element-18897" />
              <span data-id="element-18898">Privacy & Safety</span>
            </button>
            {userType === 'angel' && <button className={`w-full flex items-center gap-3 px-4 py-3 text-left ${activeSection === 'subscription' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'text-gray-700 dark:text-gray-300'}`} onClick={() => setActiveSection('subscription')} data-id="element-18899">
                <CreditCard size={18} data-id="element-18900" />
                <span data-id="element-18901">Subscription Pricing</span>
              </button>}
          </div>}
      </div>
      {/* App Settings Group */}
      <div data-id="element-18902">
        <button className="w-full flex items-center justify-between p-4 bg-gray-100 dark:bg-gray-800" onClick={() => toggleGroup('app')} data-id="element-18903">
          <span className="font-semibold text-sm text-gray-700 dark:text-gray-300" data-id="element-18904">
            App Settings
          </span>
          {expandedGroup === 'app' ? <ChevronUp size={18} className="text-gray-500" data-id="element-18905" /> : <ChevronDown size={18} className="text-gray-500" data-id="element-18906" />}
        </button>
        {expandedGroup === 'app' && <div className="py-1" data-id="element-18907">
            <button className={`w-full flex items-center gap-3 px-4 py-3 text-left ${activeSection === 'notifications' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'text-gray-700 dark:text-gray-300'}`} onClick={() => setActiveSection('notifications')} data-id="element-18908">
              <Bell size={18} data-id="element-18909" />
              <span data-id="element-18910">Notifications</span>
            </button>
            <button className={`w-full flex items-center gap-3 px-4 py-3 text-left ${activeSection === 'general' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'text-gray-700 dark:text-gray-300'}`} onClick={() => setActiveSection('general')} data-id="element-18911">
              <Settings size={18} data-id="element-18912" />
              <span data-id="element-18913">General</span>
            </button>
            <button className={`w-full flex items-center gap-3 px-4 py-3 text-left ${activeSection === 'display' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'text-gray-700 dark:text-gray-300'}`} onClick={() => setActiveSection('display')} data-id="element-18914">
              <Monitor size={18} data-id="element-18915" />
              <span data-id="element-18916">Display</span>
            </button>
          </div>}
      </div>
    </div>;
};